import { render } from "./UserIndexTitle.vue?vue&type=template&id=2ecdf58d&scoped=true"
import script from "./UserIndexTitle.vue?vue&type=script&lang=js"
export * from "./UserIndexTitle.vue?vue&type=script&lang=js"

import "./UserIndexTitle.vue?vue&type=style&index=0&id=2ecdf58d&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecdf58d"]])

export default __exports__